import PropTypes from 'prop-types';

import CardModule from '../../molecules/shared/card-module';

import { className } from '../../../utils/GlobalCssProxy';

const disclosuresBySection = {
  allocation: { header: 'Disclosure', text: 'Portfolio information in the charts is based on the fund\'s net assets. These percentages may differ from those used for the fund\'s prospectus, regulatory, and other investment policies and may include or exclude various categories of investments in the portfolio allocation.' }
};

const TemplateSectionDisclosure = ({ section }) => {
  const currentSectionDisclosures = disclosuresBySection[section];

  return (
    <CardModule {...className('bg-transparent', 'template-section-disclosure')}>
      <h3 {...className('font-size-14', 'text-gray-500')}>
        {currentSectionDisclosures.header}
      </h3>
      <p {...className('paragraph-standard', 'font-size-14', 'mb-0')}>
        {currentSectionDisclosures.text}
      </p>
    </CardModule>
  );
};

TemplateSectionDisclosure.propTypes = {
  section: PropTypes.oneOf(['allocation'])
};

export default TemplateSectionDisclosure;
